<div
  class="dialog-content service-dialog"
  fxLayout="column"
  fxLayoutAlign="space-between"
>
  <div class="logo-center">
    <img
      alt="Republic Services logo"
      width="128"
      src="/assets/rs-logo-with-text.svg"
    />
  </div>
  <h2>
    Thank you for registering for the Republic Services Special Waste Online
    Account
  </h2>
  <ul>
    <li>
      You will receive an email confirming that we have verified your account.
      After you receive the verification email you can begin submitting new
      waste profiles.
    </li>
    <li>
      If you do not already see waste profiles on your Waste Profiles page: All
      existing waste profiles associated to your company will be imported to
      your portal as soon as possible.
    </li>
    <li>
      Tip: If you would like to see disposal destinations for specific states on
      the waste profile form, please navigate to your settings page by clicking
      your name in the top right corner of the page. Select Settings in the drop
      down menu, then select one or more states under the Disposal Site States
      field. 
    </li>
  </ul>
  <button
    mat-icon-button
    cdkFocusInitial
    class="close"
    aria-label="Close dialog"
    color="accent"
    [disableRipple]="true"
    [mat-dialog-close]=""
    (click)="closeDialog()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
